// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'

window.debito_mensaje_estado = 0;

Vue.config.productionTip = true;
axios.defaults.headers.post['ms-update'] = window.sssdi;
axios.defaults.headers.get['ms-update'] = window.sssdi;
Vue.prototype.dvids = window.sssdi;
axios.defaults.withCredentials = true;
Vue.prototype.$http = axios;

Vue.prototype.formatterNumber = new Intl.NumberFormat('es-AR', {
  style: 'currency',
  currency: 'ARS'

})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js